import { useTypedParams } from '@sorare/routing';

import { useIntlContext } from '@sorare/core/src/contexts/intl';

import { Post } from 'components/Post';
import type { BlogSport } from 'constants/types';

import type { PageParams } from './__generated__/routeParams';

const PostPage = () => {
  const { slug, sport } = useTypedParams<PageParams>();
  const { language } = useIntlContext();

  return (
    <Post sportCategory={sport as BlogSport} slug={slug} language={language} />
  );
};

export default PostPage;
